import { API_URLS } from '../config/apiConfig';

/**
 * Get secure preview URL for an admin AI test generation
 * 
 * @param {number} generationId - The generation ID
 * @param {string} type - Optional type (e.g., 'enhanced')
 * @returns {string} - URL for the admin AI test generation preview
 */
export const getAdminAITestPreviewUrl = (generationId, type = null) => {
  let baseUrl = `${API_URLS.ADMIN_BASE}/ai-test/preview/${generationId}`;
  
  if (type) {
    baseUrl += `?type=${type}`;
  }
  
  return baseUrl;
};

/**
 * Get secure video stream URL for an admin AI test generation
 * 
 * @param {number} generationId - The generation ID
 * @returns {string} - URL for the admin AI test generation video stream
 */
export const getAdminAITestVideoStreamUrl = (generationId) => {
  const baseUrl = `${API_URLS.ADMIN_BASE}/ai-test/preview/${generationId}`;
  return baseUrl;
};

/**
 * Get secure image URL for an admin AI test generation
 * 
 * @param {number} generationId - The generation ID
 * @returns {string} - URL for the admin AI test generation image
 */
export const getAdminAITestImageUrl = (generationId) => {
  const baseUrl = `${API_URLS.ADMIN_BASE}/ai-test/preview/${generationId}`;
  return baseUrl;
};
